module.exports = __webpack_public_path__ + "img/gezi.e2162762.png";